<template>
  <div class="promo-article">
    <BHLink
      v-if="promo.url"
      class="promo-article__link"
      :href="promo.url"
      target="_blank"
      @click="sendAnalytics(promo.url)"
    />
    <div class="promo-article__wrapper">
      <div class="promo-article__analytics">
        <div class="promo-article__header">
          <ArticleCard
            :article="article"
            :hide-label-card-footer="true"
          />
        </div>
        <div
          v-if="article"
          class="promo-article__content"
        >
          <template
            v-for="(content, index) in article.parsed_content"
            :key="index"
          >
            <TheContent :elem="content" />
          </template>
        </div>
        <div class="promo-article__footer">
          <PromoArticleFooter />
        </div>
      </div>
      <div
        v-if="article"
        class="promo-article__content--promo-authors"
      >
        <div class="promo-article__authors-wrapper">
          <p class="promo-article__author">
            Сделано в
            <BHLink
              class="promo-article__main-link"
              href="/"
              >Горящей избе</BHLink
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import PromoArticleFooter from './PromoArticleFooter.vue';
  import TheContent from '~/components/TheContent';
  import ArticleCard from '~/components/ArticleCard.vue';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import { useSingleArticleStore } from '~/store/singleArticle';
  import BHLink from '~/components/BHLink.vue';

  export default defineNuxtComponent({
    name: 'PromoArticle',

    components: {
      BHLink,
      TheContent,
      ArticleCard,
      PromoArticleFooter,
    },

    computed: {
      article() {
        return useSingleArticleStore().article;
      },

      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },

      promo() {
        return this.article?.meta?.promo;
      },
    },

    methods: {
      // Аналитики клика ссылки в промо
      sendAnalytics(_promoLink: string) {},
    },
  });
</script>

<style lang="scss" scoped>
  @use '~/scss/article' as *;

  .promo-article {
    &__wrapper {
      background: #ffffff;
      border-radius: 32px;
      padding-bottom: $spacing-8;
      position: relative;
      @include tablet {
        margin: 0 $spacing-1;
        border-radius: 60px;
        padding-bottom: $spacing-10;
      }
      @include desktop {
        margin: 0 160px;
      }

      @media (min-width: 1600px) {
        margin: 0 auto;
        max-width: 1280px;
      }
    }

    &__link {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }

    @include header-margin;

    &__header {
      .article-card {
        @include big-tablet {
          padding-top: $spacing-8;
        }

        @include desktop {
          padding-top: $spacing-9;
        }
      }
    }

    &__content {
      box-sizing: content-box;
      margin: 0 auto;
      max-width: 732px;
      padding: 0 $spacing-4 0;
      overflow-x: hidden;
      @include tablet {
        padding: 0 $spacing-16 0;
      }

      @include big-tablet {
        max-width: 732px;
      }

      @include desktop {
        padding: 0 $spacing-19;
      }

      @include article-picture-styles;
    }

    &__content :deep() > {
      @include article-elems;
      @include lead-styles;
    }

    &__footer {
      width: 100%;
      margin-top: $spacing-8;
      margin-bottom: $spacing-6;
      @include tablet {
        margin-top: $spacing-10;
      }
    }

    &__content--promo-authors {
      margin-top: $spacing-6;
      padding: 0 $spacing-4 0;
      box-sizing: content-box;
      max-width: 732px;
      @include tablet {
        padding: 0 $spacing-16 0;
        margin: 0 auto 0;
      }
    }

    &__authors-wrapper {
      border-top: 1px solid $stroke-color--1;
      padding-top: $spacing-4;
      color: #292236;
    }

    &__author {
      text-align: center;
      font-family: $text-font--1;
      @include normalText;
      a {
        @include link-styles;
      }
    }
  }
</style>
